/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Wunschsprache_German_English13Inputs */

const en__field__enum_wunschsprache_german_english13 = /** @type {(inputs: _Field__Enum_Wunschsprache_German_English13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`German and English`)
};

const de__field__enum_wunschsprache_german_english13 = /** @type {(inputs: _Field__Enum_Wunschsprache_German_English13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch und Englisch`)
};

/**
* | output |
* | --- |
* | "German and English" |
*
* @param {_Field__Enum_Wunschsprache_German_English13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_wunschsprache_german_english13 = /** @type {((inputs?: _Field__Enum_Wunschsprache_German_English13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Wunschsprache_German_English13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_wunschsprache_german_english13(inputs)
	return de__field__enum_wunschsprache_german_english13(inputs)
});
export { _field__enum_wunschsprache_german_english13 as "_field__enum_wunschsprache_GERMAN_ENGLISH" }